import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function LegalPage({ title, children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-maaich-black font-body py-24 md:py-32">
      <div className="container mx-auto px-5 max-w-[800px]">
        <Link to="/" className="inline-flex items-center gap-2 text-maaich-black/40 hover:text-maaich-lime transition-colors mb-12 font-display uppercase italic">
          <SafeIcon icon={FiIcons.FiArrowLeft} /> Torna alla Home
        </Link>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="prose prose-lg max-w-none"
        >
          <h1 className="text-4xl md:text-5xl font-display uppercase italic mb-12 border-b-4 border-maaich-lime pb-4 leading-none">
            {title}
          </h1>
          <div className="legal-content space-y-8 leading-relaxed text-maaich-black/80">
            {children}
          </div>
        </motion.div>
      </div>
      
      <style>{`
        .legal-content h2 { font-family: 'Anton', sans-serif; text-transform: uppercase; font-style: italic; font-size: 1.5rem; margin-top: 2rem; color: #0D0D0D; }
        .legal-content h3 { font-weight: bold; font-size: 1.25rem; margin-top: 1.5rem; color: #0D0D0D; }
        .legal-content p { margin-bottom: 1rem; }
        .legal-content ul { list-style-type: disc; padding-left: 1.5rem; margin-bottom: 1rem; }
        .legal-content li { margin-bottom: 0.5rem; }
      `}</style>
    </div>
  );
}